import styles from './../styles/section-slider.scss';
import Slider1 from './slider1';
import Contacto from './contact-form';
import slider1 from '../img/slider-1/1.jpeg';
import slider2 from '../img/slider-1/2.jpeg';
import slider3 from '../img/slider-1/3.jpeg';
import slider4 from '../img/slider-1/4.jpeg';
import slider5 from '../img/slider-1/5.jpeg';
import slider6 from '../img/slider-1/6.jpeg';
import slider7 from '../img/slider-1/7.jpeg';
import slider8 from '../img/slider-1/8.jpeg';
import slider9 from '../img/slider-1/9.jpg';
import slider10 from '../img/slider-1/10.jpeg';
import slider11 from '../img/slider-1/11.jpg';
import slider12 from '../img/slider-1/12.jpg';
import React from 'react';
import {
  Row,
  Col
} from 'reactstrap';
const items = [{
    src: slider1,
    altText: 'Slider 1',
    key: 1,
  },
  {
    src: slider2,
    altText: 'Slider 2',
    key: 2,
  },
  {
    src: slider3,
    altText: 'Slider 3',
    key: 3,
  },
  {
    src: slider4,
    altText: 'Slider 4',
    key: 4,
  },
  {
    src: slider5,
    altText: 'Slider 5',
    key: 5,
  },
  {
    src: slider6,
    altText: 'Slider 6',
    key: 6,
  },
  {
    src: slider7,
    altText: 'Slider 7',
    key: 7,
  },
  {
    src: slider8,
    altText: 'Slider 8',
    key: 8,
  },
  {
    src: slider9,
    altText: 'Slider 9',
    key: 9,
  },
  {
    src: slider10,
    altText: 'Slider 10',
    key: 10,
  },
  {
    src: slider11,
    altText: 'Slider 11',
    key: 11,
  },
  {
    src: slider12,
    altText: 'Slider 12',
    key: 12,
  },
];
const Section1 = (props) => {
  return ( <
    div >
    <
    Row className = {
      styles.section1 + ' mx-0'
    } >
    <
    Col sm = "0"
    lg = "3"
    className = {
      styles.section1Col1 + ' px-0'
    } > < /Col> <
    Col sm = "12"
    lg = "9"
    className = {
      'px-0'
    } >
    <
    Slider1 items = {
      items
    } > < /Slider1> <
    /Col> <
    Contacto > < /Contacto> <
    /Row> <
    /div>
  );
};
export default Section1;